import { observable, action, computed } from 'mobx';
import { setter } from 'mobx-decorators';
import agent from '../services/web/agent';
import AuthenticationProviderType from '../services//enums/authenticationProviderType';
import AuthStore from './authStore';
class AuthenticationProvidersStore {
    
    @setter @observable authenticationProviders;

    @observable inProgress = false;

    @setter @observable isIpAuthorized;

    @action getAllAuthenticationProviders() {

        return agent.AuthenticationProviders.getAllAuthenticationProviders()
            .then(action((authenticationProviders) => {
                this.isIpAuthorized = true;
                return this.authenticationProviders = authenticationProviders;
            }))
            .catch(action((err) => {
                this.isIpAuthorized = false;
            }));
    }

    @action getAllAuthenticationProvidersOfTenant() {
        this.inProgress = true;
        var encodedTenantName = encodeURIComponent(AuthStore.values.tenant);
        return agent.AuthenticationProviders.getAllAuthenticationProvidersOfTenant(encodedTenantName)
            .then(action((authenticationProviders) => {
                this.inProgress = false;
                this.isIpAuthorized = true;
                return this.authenticationProviders = authenticationProviders;
            }))
            .catch(action((err) => {
                this.isIpAuthorized = false;
            }));
    }

    @computed get isAnyExternalAuthenticationProviderExist() {

        if (this.authenticationProviders === undefined) {
        
            return;
        }

        const externals = this.authenticationProviders.filter(authenticationProvider => {

            return authenticationProvider.isExternal;
        });

        return externals.length > 0;
    }

    @computed get windowsAuthenticationProvider() {
      
        return this.getSingleAuthenticationProviderByType(AuthenticationProviderType.Windows);
    }

    getApplicationAuthenticationProvider() {

        return this.getSingleAuthenticationProviderByType(AuthenticationProviderType.Application);
    }

    getSingleAuthenticationProviderByType(type) {

        if (this.authenticationProviders === undefined) {
        
            return;
        }

        const provider = this.authenticationProviders.filter(authenticationProvider => 
            authenticationProvider.providerType.toLowerCase() === type.toLowerCase());

        return provider.length > 0 ? provider[0] : undefined;
    }

}

export default new AuthenticationProvidersStore();


// WEBPACK FOOTER //
// ./src/stores/authenticationProvidersStore.js